// The Home numbers that need ALL of a company's cases (needs review, money caught, bills checked, cases to check).
//
// They come from ONE backend call (GET /api/home/case-totals, computed inside the database). If that call is not
// available, for example a website deployed before its backend, the same numbers are computed here the way Home
// always did (a head count plus a download of every case), and a warning is written to the browser console naming
// the route and the reason.
import { pageAll } from './pageAll';
import { isMoneyCaught } from './moneyCaught';

// The old Home formulas, unchanged. Also the reference the tests compare the backend and the database with.
export function totalsFromRows(rows) {
  const list = rows || [];
  const caught = list.filter(isMoneyCaught).reduce((s, c) => s + Number(c.discrepancy_amount || 0), 0);
  // Bills, not cases: a case opened by an order still waiting for its invoice has had no bill to check.
  const billsChecked = list.filter((c) => c.invoice_id).length;
  // What is genuinely still open, not the total ever processed.
  const casesToCheck = list.filter((c) => c.invoice_id).length
    - list.filter((c) => c.discrepancy_type === null && c.invoice_id).length
    + list.filter((c) => c.discrepancy_type).length;
  return { caught, billsChecked, casesToCheck };
}

const isCount = (v) => typeof v === 'number' && Number.isFinite(v);

// -> { needsReview, caught, billsChecked, casesToCheck }; every value is null when it could not be read
//    (a failed read must show nothing rather than a confident 0).
export async function loadHomeCaseTotals({ apiFetch, supabase, orgId }) {
  let reason;
  try {
    const res = await apiFetch('/api/home/case-totals');
    if (res.ok) {
      const j = await res.json();
      if (j && j.ok && isCount(j.needs_review) && isCount(j.money_caught) && isCount(j.bills_checked) && isCount(j.cases_to_check)) {
        return { needsReview: j.needs_review, caught: j.money_caught, billsChecked: j.bills_checked, casesToCheck: j.cases_to_check };
      }
      reason = 'unexpected_answer';
    } else {
      reason = `status_${res.status}`;
    }
  } catch {
    reason = 'request_failed';
  }
  // eslint-disable-next-line no-console
  console.warn(`[fallback] route=/api/home/case-totals reason=${reason}`);

  const [headRes, allRes] = await Promise.all([
    supabase.from('cases').select('id', { count: 'exact', head: true }).eq('organization_id', orgId).eq('status', 'needs_review'),
    pageAll(() => supabase.from('cases')
      .select('discrepancy_type, discrepancy_amount, invoice_id')
      .eq('organization_id', orgId)
      .order('id', { ascending: true })),
  ]);
  const needsReview = headRes.error ? null : headRes.count ?? 0;
  if (allRes.error) return { needsReview, caught: null, billsChecked: null, casesToCheck: null };
  const t = totalsFromRows(allRes.data || []);
  return { needsReview, ...t };
}
